<template>
  <div class="cmatches mt-8" v-if="filteredMatches.length || isFetchingMatches">
    <h2 class="text-center">Inbox</h2>
    <div v-if="isFetchingMatches">
      <v-skeleton-loader v-for="i in 5" :key="i" type="list-item" />
    </div>
    <div v-else>
      <div v-for="match in filteredMatches" :key="match.id">
        <MatchesItem :match="match" />
      </div>
    </div>
  </div>
</template>

<script>
import MatchesItem from "@/components/dashboard/matches/MatchItem";
import { filter } from "lodash";

export default {
  props: {
    isFetchingMatches: Boolean,
    matches: Array
  },
  components: {
    MatchesItem
  },
  computed: {
    filteredMatches() {
      return filter(this.matches, match => match.status !== "ignored");
    }
  }
};
</script>

<style lang="scss"></style>
